import { make } from 'vuex-pathify';
import { isEqual, omit } from 'lodash';
import cloneDeep from 'src/utils/objectOperations/cloneDeep';
import Vue from 'vue';
import getOptionValue from '../preferences/getOptionValue';
const state = {
    currentMode: {
        name: undefined,
        componentName: undefined,
        component: null,
        componentProps: null,
        // @ts-expect-error
        props: {},
        // various display options
        hideLayoutHeader: false,
        leftDrawerOpen: true,
        hideHistoryButtons: null,
        reinitializationRequested: false,
        fetchDataRequested: null,
        dataReloadInCurrentPaginationAndFilterContextRequested: null
    },
    history: [],
    currentHistoryStep: 0,
    currentTreeMode: 'Intake' // don't use. was app specific
};
const mutations = make.mutations(state);
const namespaced = true;
const actions = {
    setCurrentMode({ commit, state, dispatch }, newMode) {
        const oldMode = cloneDeep(state.currentMode);
        commit('SET_CURRENT_MODE', newMode);
        if (newMode.documentTitle)
            document.title = newMode.documentTitle;
        const newHref = !newMode.preserveDisplayedUrl ? location.origin : null;
        const keysThatDontTriggerHistoryStepCreation = [
            'leftDrawerOpen'
        ];
        if (!newMode.doNotWriteToHistory && !newMode.thisIsHistoryMovement && !(isEqual(omit(oldMode, keysThatDontTriggerHistoryStepCreation), omit(newMode, keysThatDontTriggerHistoryStepCreation)))) {
            if (state.history.length === 0) {
                commit('SET_HISTORY', [newMode]);
                commit('SET_CURRENT_HISTORY_STEP', 0);
                window.history.replaceState({ step: 0 }, newMode.documentTitle || '', newHref);
            }
            else if (newMode.replaceCurrentModeInHistory) {
                const newState = cloneDeep(state.history);
                newState[state.currentHistoryStep] = newMode;
                commit('SET_HISTORY', newState);
                window.history.replaceState({ step: state.currentHistoryStep }, newMode.documentTitle || '', newHref);
            }
            else {
                commit('SET_HISTORY', [...state.history.slice(0, state.currentHistoryStep + 1), newMode, ...state.history.slice(state.currentHistoryStep + 1)]);
                window.history.pushState({ step: state.currentHistoryStep + 1 }, newMode.documentTitle || '', newHref);
                commit('SET_CURRENT_HISTORY_STEP', state.currentHistoryStep + 1);
            }
        }
        // truncate history if it is too long
        const countOfHistoryStepsToKeep = Number(getOptionValue(23)) || 10;
        if (state.history.length > countOfHistoryStepsToKeep) {
            commit('SET_HISTORY', state.history.slice(state.history.length - countOfHistoryStepsToKeep));
        }
        // This fixes issue of Quasar button tooltip stay on screen after new component was put into mode window
        Vue.nextTick(() => {
            const elementToRemove = document.querySelectorAll('.q-tooltip')[0];
            if (elementToRemove === null || elementToRemove === void 0 ? void 0 : elementToRemove.parentNode)
                elementToRemove.parentNode.removeChild(elementToRemove);
        });
        // this is for old apps. don't do this anymore this way, because we're now (starting app 11) passing component not name, into currentMode
        if (newMode.name === 'complaint-create')
            dispatch('currentComplaint/resetCurrentComplaint', null, { root: true });
        if (newMode.name === 'complaints-view')
            dispatch('complaints/complaintsView', newMode.id, { root: true });
        if (newMode.name === 'products-view')
            dispatch('products/productsView', newMode.id, { root: true });
        if (newMode.name === 'suppliers-view')
            dispatch('suppliers/suppliersView', newMode.id, { root: true });
    },
    saveCurrentModeAsHistoryStep({ state, dispatch, commit }, params) {
        // console.log()
    },
    requestComponentReinitialization({ state, commit }, params) {
        commit('SET_CURRENT_MODE', Object.assign(Object.assign({}, state.currentMode), { reinitializationRequested: true }));
    },
    requestComponentFetchData({ state, commit }, params) {
        commit('SET_CURRENT_MODE', Object.assign(Object.assign({}, state.currentMode), { fetchDataRequested: true }));
    },
    mixIntoCurrentMode({ state, dispatch, commit }, params) {
        const newState = Object.assign(Object.assign(Object.assign({}, state.currentMode), params), { replaceCurrentModeInHistory: true });
        dispatch('setCurrentMode', newState);
    },
    goToPreviousMode() { window.history.back(); },
    goToNextMode() { window.history.forward(); },
    handleHistoryPopState({ state, dispatch, commit }, poppedState) {
        if (!poppedState || !poppedState.step || !state.history[poppedState.step])
            return;
        const newState = cloneDeep(state.history[poppedState.step]) || {};
        newState.thisIsHistoryMovement = true;
        dispatch('setCurrentMode', newState);
        commit('SET_CURRENT_HISTORY_STEP', poppedState.step);
    }
};
const getters = {
    previousModeExists: (state) => Boolean(state.currentHistoryStep > 0),
    nextModeExists: (state) => Boolean(state.history[state.currentHistoryStep + 1]),
    modeHistoryExists: (state, getters) => getters.previousModeExists || getters.nextModeExists,
    currentMode_reinitialization_requested: (state) => state.currentMode.reinitializationRequested
};
export function goToPreviousMode() { actions.goToPreviousMode(); }
export function destroyThenGoToPreviousMode(ctx) {
    ctx.$destroy();
    goToPreviousMode();
}
export default { state, mutations, namespaced, actions, getters };
